@if (hoveredDashboardId && !isTouchDevice()) {
  <app-dashboard-preview #renderer [dashboardId]="hoveredDashboardId"></app-dashboard-preview>
}

@if (display) {
  <div
    class="tree-node-container"
    [class.is-hidden]="hidden"
    [class.is-item]="isItem()"
    [class.not-selectable]="!areNodeHoverDisplayed() || blocked"
    [class.role-view]="treeNodeService?.config?.displayRoles"
    [attr.data-id]="node.id"
    [attr.data-expanded]="expanded"
    [class.is-expanded]="expanded"
    [class.has-parent]="hasParent()"
    [class.is-preset-element]="node.isPreSetElement"
    [class.is-moving-item]="isMovingItem()"
    [style.left]="isMovingItem() ? mouseLeft : null"
    [style.top]="isMovingItem() ? mouseTop : null"
    [style.position]="isMovingItem() ? 'fixed' : null"
    [style.z-index]="isMovingItem() ? '999' : null"
    [class.no-role-hidden]="isNodeWithNoAccessHidden() && !hasRole()"
    [attr.data-cy]="
      isNodeWithNoAccessHidden() && !hasRole()
        ? 'tree-node-container-hidden'
        : 'tree-node-container'
    "
    (mouseenter)="onMouseIn()"
    (mouseleave)="onMouseOut()"
  >
    <!--      [display]="isRootElement()"-->
    <div
      appUserGuide
      [userGuideDisplay]="isRootElement()"
      [userGuideId]="0"
      userGuideTooltipPosition="right"
      class="tree-node"
      [class.selected]="isNodeSelected()"
      [class.selected-highlight]="isParentItemSelected()"
      [class.blocked]="blocked"
    >
      <div
        class="node"
        matRipple
        [class.new]="isNew()"
        [class.highlighted]="isHighlighted()"
        (click)="nodeClicked()"
        (keydown.enter)="nodeClicked()"
        (keydown.space)="nodeClicked()"
        tabindex="0"
      >
        <div
          appPreventClickPropagation
          class="move-overlay"
          [class.move-mode]="showOverlay()"
          (click)="nodeClicked()"
          (keydown.enter)="nodeClicked()"
          (keydown.space)="nodeClicked()"
          [matTooltip]="(isMoveMode() ? getMoveTooltipValue() : 'TREE.SELECT') | translate"
          tabindex="0"
        ></div>
        <a class="node-name" [attr.data-cy]="node.item_name | translate">
          <mat-icon svgIcon="{{ getIcon(node.icon) }}"></mat-icon>
          <span class="name">{{ node.item_name | translate }}</span>
          <!--          children count:: {{node.children_count}}-->
        </a>
        <span
          [attr.data-cy]="(node.item_name | translate) + '-node-actions'"
          class="node-actions"
          [class.touch-device]="isTouchDevice()"
          [class.always-visible]="displayRoles() || (isRootElement() && isTouchDevice())"
          appPreventClickPropagation
        >
          @if (
            !displayRoles() &&
            (!isTouchDevice() ||
              (isTouchDevice() && isNodeSelected()) ||
              (isRootElement() && isTouchDevice()))
          ) {
            <app-tree-node-actions
              [node]="node"
              [treeNodeService]="treeNodeService"
            ></app-tree-node-actions>
          }
          @if (displayRoles() && isPermissionNode()) {
            <app-tree-node-permission
              [node]="node"
              [treeNodeService]="treeNodeService"
            ></app-tree-node-permission>
          }
        </span>
        @if (hasChildren() && !isRootElement()) {
          <button
            class="tree-action-button expand-toggle-button"
            appPreventClickPropagation
            [attr.data-cy]="(node.item_name | translate) + '-node-toggle'"
            [attr.aria-label]="'Toggle ' + node.item_name"
            (click)="toggleExpand()"
            [class.expanded]="expanded"
          >
            <mat-icon class="mat-icon-rtl-mirror"> expand_more</mat-icon>
          </button>
        } @else {
          <div class="spacer"></div>
        }
      </div>
      <div class="node-spacer"></div>
    </div>
    @if (hasChildren() && expanded) {
      <div class="expandable">
        @if (children$ | async; as children) {
          @for (child of children; track child.id) {
            @defer (on viewport) {
              <app-tree-node
                [attr.data-cy]="(child.item_name | translate) + '-node'"
                [data]="{ node: child, treeNodeService: treeNodeService }"
              ></app-tree-node>
            } @placeholder {
              <app-simple-loading></app-simple-loading>
            }
          }
          @for (temp of temporaryChildren; track temp.id) {
            <app-tree-node
              [new]="true"
              [attr.data-cy]="temp.item_name + '-node'"
              [data]="{ node: temp, treeNodeService: treeNodeService }"
            ></app-tree-node>
          }
        } @else {
          <app-simple-loading></app-simple-loading>
        }
      </div>
    }
  </div>
}
